"use strict";

//burger menu//
const btnBurger = document.querySelector(".nav__button");
btnBurger.addEventListener("click", burgerMenu);
const links = document.querySelector(".nav__list");
links.addEventListener("click", burgerMenu);

function burgerMenu(){

    if(!document.body.hasAttribute("data-menu")){
        document.body.setAttribute("data-menu", true);
        if(!document.body.hasAttribute("data-menu")){
        var tl = gsap.timeline();
        tl.from(".nav", {x:400})
          .to(".nav", {x:0, duration: 0.5})
          .from(".nav__list--el1", {x:20, opacity: 0})
          .to(".nav__list--el1", {x:0, duration: 0.3, ease: "elastic", opacity: 1}, "-=0.3")
          .from(".nav__list--el2", {x: 20, opacity: 0})
          .to(".nav__list--el2", {x:0, duration: 0.3, ease: "elastic"}, "-=0.3")
          .from(".nav__list--el3", {x: 20, opacity: 0})
          .to(".nav__list--el3", {x:0, duration: 0.3, ease: "elastic"}, "-=0.3")
          .timeScale(2);
        }


    }else{
        document.body.removeAttribute("data-menu");
    }
}




//date//
let date = new Date().getFullYear();
document.getElementById("annee").innerHTML = date;

//audio btn//
const soundBtn = document.querySelector(".btn--cerf");
soundBtn.addEventListener("click", music);


function music (){
  var myAudio2 = document.querySelector(".audioo");
    if(!document.body.hasAttribute("music-on")){
        document.body.setAttribute("music-on", true);
        soundBtn.classList.add("playAnim");
        myAudio2.play();
    } else{
        document.body.removeAttribute("music-on");
        soundBtn.classList.remove("playAnim");
        myAudio2.pause();
    }
}


//afficher bonne section
let buttons = document.querySelectorAll(".nav__list--button");
for(let button of buttons){
	button.addEventListener("click", (e)=>{
		let tabs = document.querySelectorAll(".tabContent");
		for(let tab of tabs){
			tab.classList.add("hidden");
		}

		let tabId = e.currentTarget.getAttribute("data-tab");
		let currentTab = document.getElementById(tabId);
		currentTab.classList.remove("hidden");
  });
}


//page a propos
var buttonPropos = document.querySelector(".nav__link--apropos");
buttonPropos.addEventListener("click", propos);
function propos(){
  var tl2 = gsap.timeline();
  tl2.from(".title--second", {opacity: 0})
    .to(".title--second", {opacity: 1})
    .from(".section__second--text1", {opacity: 0, delay: 0.2, ease: "power1.easeIn"})
    .to(".section__second--text1", {opacity:1})
    .from(".section__second--text2", {opacity:0, delay: 0.2, ease: "power1.easeIn"})
    .to(".section__second--text2", {opacity: 1})
    .from(".images--groupe", {opacity: 0, x: -100})
    .to(".images--groupe", {opacity: 1, x:0});
}


//page decouvrir 
var buttonDecouvrir = document.querySelector(".nav__link--decouvrir");
buttonDecouvrir.addEventListener("click", decouvrir);
function decouvrir(){
  var tl3 = gsap.timeline();
  tl3.from(".title--second", {opacity: 0})
    .to(".title--second", {opacity: 1})
    .from(".container__img", {opacity: 0})
    .to(".container__img", {opacity: 1})
    .from(".container__progress", {opacity: 0}, "-=0.5")
    .to(".container__progress", {opacity: 1})
    .from(".button__slider", {opacity: 0,}, "-=0.5")
    .to(".button__slider", {opacity: 1})
}

//taille svg en fonction de l'écran
var svg = document.querySelector(".svg--line");
if (window.matchMedia("(min-width: 2560px)").matches) {
    svg.getAttribute("height");
    svg.setAttribute("height", "500");
    svg.getAttribute("width");
    svg.setAttribute("width", "1200");
  } else if (window.matchMedia("(min-width: 1920px)").matches) {
    svg.getAttribute("height");
    svg.getAttribute("width");
    svg.setAttribute("height", "300");
    svg.setAttribute("width", "900");
  }else if(window.matchMedia("(min-width: 1600px)").matches){
    svg.getAttribute("height");
    svg.getAttribute("width");
    svg.setAttribute("height", "300");
    svg.setAttribute("width", "700");
  }else if (window.matchMedia("(min-width: 1200px)").matches){
    svg.getAttribute("height");
    svg.getAttribute("width");
    svg.setAttribute("height", "200");
    svg.setAttribute("width", "600");
  } else if (window.matchMedia("(min-width: 768px)").matches) {
    svg.getAttribute("height");
    svg.getAttribute("width");
    svg.setAttribute("height", "300");
    svg.setAttribute("width", "800");
  }
  


//lecteur de musique slider 
//titre des chansons
const songs = ['Black', 'Colours', 'Monument', 'Spirit', 'Would'];
let songIndex = 0;
//la fonction goSong va exécuter les chansons en commençant par l'index 0
goSong(songs[songIndex]);

//titre des chansons et images
function goSong(song){
  const cover = document.querySelector('#cover');
  const audio = document.querySelector('#audio');
    //on remplace la source par le nom du tableau des chansons (également le nom des images)
    audio.src = `assets/chansons/${song}.mp3`;
    audio.src = `assets/chansons/${song}.ogg`;
    cover.src = `assets/images/${song}.png`;
    if(devicePixelRatio){
    cover.src = `assets/images/${song}@2x.png`;
    }
}


//ajouter classe play pour jouer la chanson
const musicContainer = document.querySelector('.container__music');
const playBtn = document.querySelector('.button__slider--actionBig');
const audio = document.querySelector('#audio');

function playSong() {
  //ajouter une classe sur le container
    musicContainer.classList.add('play');
    //ajouter une classe sur le bouton et retirer la classe de base
    playBtn.classList.add('pause');
    playBtn.classList.remove('playplay');
    //faire play lorsque la classe pause est sur le bouton
    audio.play();
}


//ajouter classes pause pour arrêter la chanson
function pauseSong(){
  //retirer une classe du container
  musicContainer.classList.remove('play');
  //ajouter une classe sur le bouton et retirer la classe de base
  playBtn.classList.add('playplay');
  playBtn.classList.remove('pause');
  //faire pause lorsque la classe pause est sur le bouton
  audio.pause();
}

//bouton précédant
const prevBtn = document.querySelector('.button__slider--prev');
prevBtn.addEventListener("click", prevSong);

function prevSong(){
  //reculer dans le tableau
    songIndex--;
    if(songIndex < 0){
        songIndex = songs.length - 1;
    }
    goSong(songs[songIndex]);
    playSong();
    //animation de l'image du single
    var tl6 = gsap.timeline();
    tl6.from(".container__img", {opacity: 0, x:-50})
    .to(".container__img", {opacity: 1, x:0});

}


//bouton suivant
const nextBtn = document.querySelector('.button__slider--next');
nextBtn.addEventListener("click", nextSong);
audio.addEventListener("ended", nextSong);
function nextSong(){
  //avancer dans le tableau
    songIndex++;
    if(songIndex > songs.length - 1){
        songIndex = 0;
    }
    goSong(songs[songIndex]);
    playSong();
    //animation de l'image du single
    var tl7 = gsap.timeline();
    tl7.from(".container__img", {opacity: 0, x:50})
    .to(".container__img", {opacity: 1, x:0});
}

//obtenir le temps actuel
//selectionner la barre de progression
audio.addEventListener("timeupdate", updateProgress);
const progress = document.querySelector('.container__progress--el');
function updateProgress(e){
    const {duration, currentTime} = e.srcElement;
    const progressPercent = (currentTime / duration) * 100;
    progress.style.width = `${progressPercent}%`;
}


//barre de progression en fonction du temps
const progressContainer = document.querySelector('.container__progress');
progressContainer.addEventListener("click", setProgress);
function setProgress(e){
    const width = this.clientWidth; 
    const clickX = e.offsetX;
    const duration = audio.duration;
    audio.currentTime = (clickX / width) * duration;
}

//si il y a play, faire play, sinon faire pause
playBtn.addEventListener('click', () =>{
  const isPlaying = musicContainer.classList.contains('play');
  if(isPlaying){
      pauseSong();
  } else {
      playSong();
  }
})


//changer l'icône du play en pause
var image_src = document.querySelector(".button__slider--actionBig");
image_src.addEventListener("click", clic);
function clic(){
  //récupérer la source et changer la source de l'image
    image_src.getAttribute("src");
    image_src.removeAttribute("src");
    image_src.setAttribute("src", "assets/images/pause-icon.png");
}
